import React from 'react'
import { DataTableCount, DataTableExpandToggle } from '../DataTable'
import { LinkedRecordsExpansion } from './useLinkedRecordsExpansion'

type LinkedRecordsCountProps<TPanel extends string> = {
    count: number
    ownerId: string
    ownerName: string
    panel: TPanel
    expansion?: LinkedRecordsExpansion<TPanel>
}

export const LinkedRecordsCount = <TPanel extends string>({
    count,
    ownerId,
    ownerName,
    panel,
    expansion,
}: LinkedRecordsCountProps<TPanel>) => {
    if (!expansion) return <DataTableCount value={count} />

    const { expandedRow, toggleExpandedRow, recordsLabelByPanel } = expansion

    return (
        <DataTableExpandToggle
            label={count}
            contentLabel={`${recordsLabelByPanel[panel].toLowerCase()} linked to ${ownerName}`}
            isExpanded={expandedRow?.id === ownerId && expandedRow.panel === panel}
            onClick={() => toggleExpandedRow(ownerId, panel)}
        />
    )
}
